module.exports = "/static/assets/8de88e99a17d81538bdeb9fcac14b346.png";